import { SizeChartShirt } from "../svgs";

const SizeChart = () => {
  return (
    <div className="body columns">
      <div className="left-column">
        <div className="shirt-size-graphic">
          <SizeChartShirt />
        </div>
      </div>
      <div className="right-column">
        <div className="size-chart-border">
          <table className="size-chart" width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td className="size-type-label">
                  Short <span>S</span>
                </td>
                <td className="size-type-label">Width</td>
                <td className="size-type-label">Length</td>
                <td className="size-type-label">Sleeve</td>
              </tr>
              <tr>
                <td className="size-label">XS</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">SM</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">MD</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">LG</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">XL</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td className="size-type-label">
                  Regular <span className="reg">R</span>
                </td>
                <td className="size-type-label">Width</td>
                <td className="size-type-label">Length</td>
                <td className="size-type-label">Sleeve</td>
              </tr>
              <tr>
                <td className="size-label">SM</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">MD</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">LG</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">XL</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="size-label">XXL</td>
                <td>16</td>
                <td>27</td>
                <td>8</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="size-chart-bottom">Shirt dimensions are in inches</div>
      </div>
    </div>
  );
};

export default SizeChart;
